import { useTranslation } from 'react-i18next';
import './PasswordRequirements.css';
import successIcon from './successIcon.svg';
import { PasswordRequirement } from './usePasswordRequirement';

export function PasswordRequirements({
  requirements,
  id,
}: {
  requirements: PasswordRequirement[];
  id: string;
}) {
  const { t } = useTranslation();
  return (
    <div className="password-requirements-container">
      <h3>{t('passwordRequirements.title')}</h3>
      <div className="password-requirements">
        {requirements.map((requirement) => (
          <PasswordRequirementLine key={requirement.id} requirement={requirement} />
        ))}
      </div>
    </div>
  );
}

function PasswordRequirementLine({ requirement }: { requirement: PasswordRequirement }) {
  const { t } = useTranslation();
  return (
    <div
      className={`password-requirement-row ${
        requirement.isSatisfied ? 'password-requirement-row--satisfied' : ''
      }`}
    >
      <span className="password-requirement-row__check">
        {requirement.isSatisfied && (
          <img
            data-testid={`password-requirement-check-${requirement.id}`}
            src={successIcon}
            alt={t('checked')}
          />
        )}
      </span>
      <span>{requirement.description}</span>
    </div>
  );
}
